module.exports = __webpack_public_path__ + "static/media/txt.7bebe2e9.svg";